import { Maybe } from 'types/graphqlTypes'
import { BookableShipmentSavedSearch } from 'apps/fleet-planner/types/apiTypes'
import { isEqualBookableShipmentSavedSearch } from 'apps/fleet-planner/utils/bookableShipmentSavedSearch'

export const findSavedLane = (
  searchFilters: Maybe<BookableShipmentSavedSearch>,
  savedLanes: BookableShipmentSavedSearch[]
): Maybe<BookableShipmentSavedSearch> => {
  if (!searchFilters) {
    return null
  }
  return savedLanes.find(lane => isEqualBookableShipmentSavedSearch(searchFilters, lane))
}
